import { Col, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router-dom';

import useAPIQuery from '../../api/useAPIQuery';
import Filter from '../../components/Filter';
import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';

const IntegrationSettingsNavigator = () => {
  const { t } = useTranslation();
  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/settings/integrations/:activeTabKey/*');
  const config = useAPIQuery('/configs/tenant-configurations/');

  return (
    <>
      <Filter>
        <Col flex={1}>
          <Radio.Group
            options={[
              {
                value: 'publication',
                label: t('Divulgações'),
              },
              ...(config.data?.enableVixtingAdmission
                ? [
                    {
                      value: 'vixtingAdmission',
                      label: 'Vixting',
                    },
                  ]
                : []),
            ]}
            onChange={({ target: { value } }) => {
              switch (value) {
                case 'publication':
                  navigate(
                    { pathname: '/:tenant/settings/integrations/publication/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'vixtingAdmission':
                  navigate(
                    {
                      pathname: '/:tenant/settings/integrations/vixtingAdmission/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'external':
                  navigate(
                    { pathname: '/:tenant/settings/integrations/external/', params: { tenant } },
                    { replace: true }
                  );
                  break;
              }
            }}
            value={match?.params?.activeTabKey || 'publication'}
            optionType="button"
          />
        </Col>
      </Filter>
      <Outlet />
    </>
  );
};

export default IntegrationSettingsNavigator;
